<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="batches"
      item-key="meta.id"
      multi-sort
      sort-by="duration.start.firebaseFormat"
      :sort-desc="true"
      :items-per-page="15"
      :footer-props="footerProps"
      :search="search"
      class="elevation-2"
      max-height="800px auto"
      @click:row="routeDetails"
      no-data-text="Keine Abrechnungsberichte vorhanden"
    >
      <template v-slot:top>
        <v-card flat>
          <v-card-subtitle>
            <v-row>
              <v-col>
                <span class="mr-4">Filter nach Status</span>
                <v-chip-group
                  v-model="batchesStateFilter"
                  mandatory
                  active-class="primary--text"
                >
                  <v-chip
                    label
                    value="all"
                    class="transparent-background font-weight-medium mr-2"
                    >Alle</v-chip
                  >
                  <v-chip
                    label
                    value="warningsToBeClosed"
                    class="transparent-background font-weight-medium mr-2"
                    >Warnungen prüfen</v-chip
                  >
                  <v-chip
                    label
                    value="payslipsToBeGenerated"
                    class="transparent-background font-weight-medium mr-2"
                    >Abrechnungszettel zu generieren</v-chip
                  >
                  <v-chip
                    label
                    value="paymentToBeInstructed"
                    class="transparent-background font-weight-medium mr-2"
                    >Auszahlung anzuweisen</v-chip
                  >
                  <v-chip
                    label
                    value="waitingOnPayment"
                    class="transparent-background font-weight-medium mr-2"
                    >Wartet auf Auszahlung</v-chip
                  >
                  <v-chip
                    label
                    value="paid"
                    class="transparent-background font-weight-medium mr-2"
                    >Ausgezahlt</v-chip
                  >
                </v-chip-group>
              </v-col>
              <!-- <v-col>
                            <span class="mr-4">Filter nach Person</span>
                            <v-autocomplete
                              :items="[]"
                              outlined
                              persistent-hint
                              return-object
                              label="Person auswählen"
                              item-text="displayName"
                              item-value="uid"
                              hide-details="auto"
                              dense
                            ></v-autocomplete>
                          </v-col> -->
            </v-row>
          </v-card-subtitle>
        </v-card>
        <v-divider></v-divider>
      </template>

      <template v-slot:group.header="{ items, isOpen, toggle }">
        <th :colspan="headers.length">
          <v-icon @click="toggle"
            >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
          </v-icon>
          {{ stripPrefix(items[0].groupBy) }}
        </th>
      </template>
      <template v-slot:[`item.user.displayName`]="{ item }">
        <div class="d-flex flex-column">
          <span
            class="d-block font-weight-semibold text--primary text-truncate"
            >{{ item.user.displayName }}</span
          >
          <!-- <small class="grey--text">{{ item.group.title }}</small> -->
          <small class="grey--text">Benutzergruppe</small>
        </div>
      </template>
      <template v-slot:[`item.period.start.timestamp`]="{ item }">
        {{ item.period.start.formattedTimestamp }}
      </template>
      <template v-slot:[`item.period.end.timestamp`]="{ item }">
        {{ item.period.end.formattedTimestamp }}
      </template>
      <template v-slot:[`item.type`]="{ item }">
        <v-chip outlined>
          {{ getPayrollTypeText(item.type) }}
        </v-chip>
      </template>
      <!-- status -->
      <template #[`item.status`]="{ item }">
        <payroll-status-chip :status="item.status" small> </payroll-status-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import PayrollStatusChip from "@/components/accounting/payroll/PayrollStatusChip.vue";
export default {
  name: "batches-data-table",
  props: {
    batches: {
      type: Array,
      required: true,
    },
  },
  components: {
    PayrollStatusChip,
  },
  data() {
    return {
      search: "",
      batchesPersonFilter: "own",
      batchesStateFilter: "inProgress",
      footerProps: {
        "items-per-page-options": [15, 25, 50, 100, -1],
      },
      headers: [
        { text: "Bezeichnung", value: "title" },
        { text: "Typ", value: "type" },
        { text: "Abrechnung von", value: "period.start.timestamp" },
        { text: "Abrechnung bis", value: "period.end.timestamp" },
        { text: "Anzahl Abrechnungszettel", value: "persons.length" },
        {
          text: "Status",
          value: "status",
          filter: (value) => {
            if (!this.batchesStateFilter) return true;
            if (this.batchesStateFilter === "all") return true;
            return value === this.batchesStateFilter;
          },
        },
      ],
    };
  },
  methods: {
    routeDetails(item) {
      this.$router.push({
        name: "accounting-payroll-details",
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: item.meta.id,
        },
      });
    },
    getPayrollTypeText(type) {
      switch (type) {
        case "regular":
          return "Regulärer Turnus";
        case "special":
          return "Sonderzahlung";
        default:
          return "Unbekannt";
      }
    },
  },
};
</script>
